<template>
  <el-card
    class="h-full position-relative"
    :body-style="{ padding: '20px', height: '100%', position: 'relative' }"
  >
    <el-tabs v-model="activeName" type="card" class="h-full">
      <el-tab-pane :label="$t('API定义')" name="first" class="h-full" v-if="editType !== 'verify'">
        <div v-loading="pageLoading" class="h-full">
          <el-row :gutter="10" class="p-10px">
            <el-form :model="applyForm" ref="applyForm" :rules="applyRules" label-width="150px">
              <el-col :span="8">
                <el-form-item :label="$t('API代码')" prop="code">
                  <el-input
                    size="small"
                    :placeholder="$t('请输入API代码')"
                    :clearable="editType !== 'read'"
                    :readOnly="editType === 'read'"
                    v-model="applyForm.code"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('API名称')" prop="name">
                  <el-input
                    size="small"
                    :placeholder="$t('请输入API名称')"
                    :clearable="editType !== 'read'"
                    :readOnly="editType === 'read'"
                    v-model="applyForm.name"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('API类型')" prop="type">
                  <template>
                    <el-select
                      class="w-full"
                      v-model="applyForm.type"
                      filterable
                      :disabled="editType === 'read'"
                      allow-create
                      clearable
                      size="small"
                      :placeholder="$t('pleaseSelect')"
                    >
                      <el-option
                        v-for="item in apiTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </template>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="API地址" prop="url">
                  <el-input
                    size="small"
                    :clearable="editType !== 'read'"
                    :readOnly="editType === 'read'"
                    :placeholder="$t('请以/开头')"
                    v-model="applyForm.url"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('请求方式')" prop="method" class="w-full">
                  <el-select
                    class="w-full"
                    v-model="applyForm.method"
                    filterable
                    :disabled="editType === 'read'"
                    clearable
                    size="small"
                    :placeholder="$t('pleaseSelect')"
                    @change="changeUrlPerfix"
                  >
                    <el-option
                      v-for="item in apiMethods"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="isPost">
                <el-form-item label="是否查询" prop="isPostQuery">
                  <el-select
                    class="w-full"
                    v-model="applyForm.isPostQuery"
                    :disabled="editType === 'read'"
                    clearable
                    size="small"
                    :placeholder="$t('pleaseSelect')"
                    @change="changeisPostQuery"
                  >
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="API地址前缀" prop="urlPerfix">
                  <el-input size="small" readOnly v-model="urlPerfix" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="请求超时(秒)" prop="timeout">
                  <el-input
                    size="small"
                    :placeholder="$t('请输入请求超时时间')"
                    :clearable="editType !== 'read'"
                    :readOnly="editType === 'read'"
                    v-model="applyForm.timeout"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="每分钟最大请求次数" prop="qps">
                  <el-input
                    size="small"
                    :placeholder="$t('请输入每分钟最大请求次数')"
                    :clearable="editType !== 'read'"
                    :readOnly="editType === 'read'"
                    v-model="applyForm.qps"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="密钥" prop="secretKey">
                  <el-input
                    size="small"
                    :placeholder="$t('请输入密钥')"
                    :clearable="editType !== 'read'"
                    :readOnly="editType === 'read'"
                    v-model="applyForm.secretKey"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('调用建议')" prop="propose">
                  <el-input
                    size="small"
                    :clearable="editType !== 'read'"
                    :readOnly="editType === 'read'"
                    type="textarea"
                    :placeholder="$t('API调用建议')"
                    v-model="applyForm.propose"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('使用场景')" prop="usageScene">
                  <el-input
                    size="small"
                    type="textarea"
                    :clearable="editType !== 'read'"
                    :readOnly="editType === 'read'"
                    :placeholder="$t('API使用场景说明')"
                    v-model="applyForm.usageScene"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('描述')" prop="description">
                  <el-input
                    size="small"
                    :clearable="editType !== 'read'"
                    :readOnly="editType === 'read'"
                    type="textarea"
                    :placeholder="$t('API简要描述')"
                    v-model="applyForm.description"
                  />
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
          <el-row :style="{ height: isPost ? 'calc(100% - 345px)' : 'calc(100% - 275px)' }">
            <div class="mb-10px flex items-center text-14px">
              <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">输入</span>
            </div>
            <el-table border class :data="inputData" height="calc(50% - 32px)" v-if="refreshTable">
              <el-table-column label="参数代码" prop="code">
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    :readOnly="editType === 'read'"
                    v-model="scope.row.code"
                    :placeholder="$t('请输入参数代码')"
                  />
                </template>
              </el-table-column>
              <el-table-column label="参数名称" prop="name">
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    :readOnly="editType === 'read'"
                    v-model="scope.row.name"
                    :placeholder="$t('请输入参数名称')"
                  />
                </template>
              </el-table-column>
              <el-table-column label="数据类型" prop="type">
                <template slot-scope="scope">
                  <el-select
                    :disabled="editType === 'read'"
                    filterable
                    clearable
                    v-model="scope.row.type"
                    class="!w-full"
                  >
                    <el-option
                      v-for="(item, index) in dataTypes"
                      :label="item.label"
                      :value="item.value"
                      :key="index"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="查询方式" prop="queryMode">
                <template slot-scope="scope">
                  <el-select
                    :disabled="editType === 'read'"
                    filterable
                    clearable
                    v-model="scope.row.queryMode"
                    class="!w-full"
                  >
                    <el-option
                      v-for="(item, index) in queryModes"
                      :label="item.label"
                      :value="item.value"
                      :key="index"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column :label="$t('操作')" width="200" v-if="editType !== 'read'">
                <template slot="header">
                  <el-button size="mini" @click="addInputCode()">新增</el-button>
                </template>
                <template slot-scope="scope">
                  <el-button size="mini" @click="deleteInputCode(scope.row)">删除</el-button>
                  <el-button
                    size="mini"
                    v-if="scope.$index !== 0"
                    @click="changeFileLevel('up', scope.$index, 'inputData')"
                    >上移</el-button
                  >
                  <el-button
                    size="mini"
                    v-if="scope.$index !== inputData.length - 1"
                    @click="changeFileLevel('down', scope.$index, 'inputData')"
                    >下移</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="mb-10px mt-10px flex items-center text-14px">
              <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">输出</span>
            </div>
            <div style="height: calc(50% - 32px)">
              <el-table
                border
                :data="outPutData"
                height="100%"
                v-loading="tableLoading"
                v-if="refreshTable"
              >
                <el-table-column label="参数代码" prop="code">
                  <template slot-scope="scope">
                    <el-input
                      size="small"
                      :readOnly="editType === 'read'"
                      v-model="scope.row.code"
                      :placeholder="$t('请输入参数代码')"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="参数名称" prop="name">
                  <template slot-scope="scope">
                    <el-input
                      size="small"
                      :readOnly="editType === 'read'"
                      v-model="scope.row.name"
                      :placeholder="$t('请输入参数名称')"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="数据类型" prop="type">
                  <template slot-scope="scope">
                    <el-select
                      :disabled="editType === 'read'"
                      filterable
                      clearable
                      v-model="scope.row.type"
                      class="!w-full"
                    >
                      <el-option
                        v-for="(item, index) in dataTypes"
                        :label="item.label"
                        :value="item.value"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('操作')" width="200" v-if="editType !== 'read'">
                  <template slot="header">
                    <el-button size="mini" @click="addOutputCode()">新增</el-button>
                  </template>
                  <template slot-scope="scope">
                    <el-button size="mini" @click="deleteOutputCode(scope.row)">删除</el-button>
                    <el-button
                      size="mini"
                      v-if="scope.$index !== 0"
                      @click="changeFileLevel('up', scope.$index, 'outPutData')"
                      >上移</el-button
                    >
                    <el-button
                      size="mini"
                      v-if="scope.$index !== outPutData.length - 1"
                      @click="changeFileLevel('down', scope.$index, 'outPutData')"
                      >下移</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('API验证')" name="second" class="h-full" v-if="editType === 'verify'">
        <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
          <!-- 参数 start -->
          <div class="overflow-y-auto overflow-x-hidden mt-10px" style="height: 300px">
            <el-form
              :model="apiVerificationForm"
              label-width="150px"
              ref="apiVerificationForm"
              class="h-full"
            >
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="API名称">
                    <el-input size="small" clearable v-model="applyForm.name" readonly />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('API格式')">
                    <el-input size="small" clearable v-model="apiAddress" readonly />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('请求方式')">
                    <el-select class="w-full" v-model="applyForm.method" disabled size="small">
                      <template v-if="!_.isEmpty(apiMethods)">
                        <el-option
                          v-for="item in apiMethods"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </template>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <div class="mb-10px flex items-center text-14px">
                <span class="border-l-3 border-color-primary w-80px pl-10px text-18px">输入</span>
                <div class="flex-1">
                  (排序文本框输入示例：id desc; 数组文本框输入示例：[{"name": "张三"}])
                </div>
              </div>
              <!-- 是post查询接口和get查询接口 -->
              <el-row
                :gutter="10"
                v-if="
                  (applyForm.isPostQuery === 1 && applyForm.method === 2) ||
                    (applyForm.isPostQuery === 0 && applyForm.method === 1)
                "
              >
                <el-col :span="8" v-for="(item, index) in queryList" :key="index">
                  <el-form-item :label="`${item.name}:`" :prop="item.code" class="w-full">
                    <el-date-picker
                      v-model="apiVerificationForm[item.code]"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      v-if="item.type === 3"
                      class="!w-full"
                    >
                    </el-date-picker>
                    <el-input
                      size="small"
                      clearable
                      v-model="apiVerificationForm[item.code]"
                      v-else
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 不是post查询接口，是post新增接口，和put，delete接口 -->
              <el-row v-else>
                <el-table :data="queryTableData" border height="202px">
                  <el-table-column
                    v-for="(item, index) in queryHeaders"
                    :key="index"
                    :label="item.label"
                    :prop="item.prop"
                  >
                    <template slot-scope="scope">
                      <el-date-picker
                        v-model="scope.row[item.prop]"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        v-if="item.type === 3"
                        class="!w-full"
                      >
                      </el-date-picker>
                      <el-input
                        v-else
                        size="small"
                        v-model="scope.row[item.prop]"
                        :placeholder="$t('请输入')"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('操作')" width="80">
                    <template slot="header">
                      <el-button size="mini" @click="addQueryData()">新增</el-button>
                    </template>
                    <template slot-scope="scope">
                      <el-button size="mini" @click="deleteQueryData(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>
            </el-form>
          </div>
          <!-- 参数 end -->
          <!-- 表格、json start -->
          <div class="mb-10px flex items-center text-14px">
            <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">输出</span>
          </div>
          <el-tabs v-model="activeApiType" type="card" style="height: calc(100% - 328px)">
            <el-tab-pane :label="$t('表格')" name="first" class="h-full">
              <el-table
                :data="apiTypeTableData"
                border
                v-loading="apiTypeTableLoading"
                height="100%"
              >
                <el-table-column
                  v-for="(item, index) in apiTypeTableHeader"
                  :key="index"
                  :label="item.label"
                  :prop="item.prop"
                ></el-table-column>
              </el-table>
              <!-- pagigation start -->
              <!-- <el-pagination
                class="mt-20px r"
                background
                @size-change="apiVertify()"
                @current-change="apiVertify()"
                :current-page.sync="page.pageNo"
                :page-sizes="[10, 15, 30]"
                :page-size.sync="page.pageSize"
                layout="->, total, sizes, prev, pager, next"
                :total="page.pageTotal"
              ></el-pagination> -->
              <!-- pagigation end -->
            </el-tab-pane>
            <el-tab-pane label="json" name="second">
              <div
                :style="{ height: apiDefinitionTableHeight }"
                v-loading="apiTypeTableLoading"
                class="overflow-y-auto"
              >
                <codemirror
                  :key="updateKey"
                  ref="myCm"
                  v-model="expression"
                  :options="cmOptions"
                  class="h-full"
                ></codemirror>
              </div>
            </el-tab-pane>
          </el-tabs>
          <!-- 表格、json end -->
        </el-card>
      </el-tab-pane>
    </el-tabs>
    <div class="position-absolute" style="position: absolute; top: 15px; right: 15px">
      <el-button
        v-if="activeName === 'first' && editType === 'edit'"
        type="primary"
        @click="releaseApi()"
        >发布</el-button
      >
      <el-button
        v-if="activeName === 'first' && !_.includes(['verify', 'read'], editType)"
        type="primary"
        @click="updateApi()"
        >保存</el-button
      >
      <el-button type="primary" size="small" @click="apiVertify()" v-if="activeName === 'second'">{{
        $t('验证')
      }}</el-button>
      <el-button @click="goBack()">返回</el-button>
    </div>
  </el-card>
</template>
<script>
import qs from 'qs'
import { codemirror } from 'vue-codemirror'
import { OpenApiApi } from '@wiz-api/open-api-management'

const openApiApi = new OpenApiApi()
export default {
  name: 'apiDefinition',
  components: {
    codemirror,
  },
  data() {
    const validateAddress = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入地址'))
        return
      }
      if (!_.startsWith(value, '/')) {
        callback(new Error('地址请以/开头'))
        return
      }
      callback()
    }
    return {
      classDialog: false,
      classForm: {},
      updateKey: 1,
      apiTypeTableLoading: false,
      pageLoading: false,
      editType: 'create',
      codeList: [],
      tableLoading: false,
      apiMethods: [],
      apiTypes: [
        {
          label: '',
          value: '',
        },
      ],
      entityTypes: [],
      expression: '',
      cmOptions: {
        tabSize: 4,
        mode: 'application/json',
        theme: 'base16-light',
        lineNumbers: true,
        lineWrapping: true,
        lineWiseCopyCut: true,
        showCursorWhenSelecting: true,
        matchBrackets: true,
        line: false,
        styleActiveLine: true,
        autoRefresh: true,
        connect: 'align',
        readOnly: false,
      },
      activeName: 'first',
      applyForm: {
        code: '', // api代码
        name: '', // api名称
        type: '', // api类型
        address: '', // 拼上/openapi/的地址
        method: '', // 请求方式
        secretKey: '', // 密钥
        propose: '', // 调用建议
        usageScene: '', // 使用场景
        description: '', // 描述
        timeout: 10, // 请求超时
        qps: 50, // 每秒调用最大次数
        isPostQuery: 0, // post 查询接口
        url: '', // 用户手动输入api地址
      },
      apiTypeTableData: [],
      apiTypeTableHeader: [],
      apiVerificationForm: {},
      queryList: [],
      activeApiType: 'first',
      page: {
        pageNo: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      applyRules: {
        name: [{ required: true, message: '请输入API名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入API代码', trigger: 'blur' }],
        type: [{ required: true, message: '请选择API类型', trigger: 'blur' }],
        method: [{ required: true, message: '请选择请求方式', trigger: 'blur' }],
        classId: [{ required: true, message: '请选择实体', trigger: 'blur' }],
        timeout: [{ required: true, message: '请选择请求超时时间', trigger: 'blur' }],
        qps: [{ required: true, message: '请选择每秒调用最大次数', trigger: 'blur' }],
        url: [
          {
            validator: validateAddress,
            trigger: 'blur',
          },
          {
            required: true,
            message: '请输入地址',
            trigger: 'blur',
          },
        ],
      },
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      dataTypes: [],
      queryModes: [],
      paramTypes: [],
      inputData: [],
      outPutData: [],
      isPost: false,
      urlPerfix: '',
      id: '',
      apiAddress: '',
      queryHeaders: [],
      queryTableData: [],
      refreshTable: true,
    }
  },
  computed: {
    postParams() {
      if (this.$route.query.token && this.applyForm.method === 'POST') {
        return {
          ...this.apiVerificationForm,
          pageno: this.page.pageNo,
          pagesize: this.page.pageSize,
          token: this.$route.query.token,
        }
      }
      return false
    },
    apiDefinitionTableHeight() {
      return `${window.innerHeight - 637}px`
    },
  },
  watch: {
    activeApiType(name) {
      if (name === 'second') {
        this.updateKey += 1
      }
    },
    inputData: {
      deep: true,
      handler(list) {
        this.queryList = _.filter(list, (item) => {
          return item
        })
        if (this.queryList.length > 0) {
          _.map(this.queryList, (item) => {
            this.queryHeaders.push({ label: item.name, prop: item.code, type: item.type })
          })
        }
        _.forEach(this.queryList, (item) => {
          // pageIndex：默认是1，pageSize：默认是：10
          if (_.includes(['pageIndex', 'pageNo'], item.code)) {
            this.$set(this.apiVerificationForm, item.code, 1)
          } else if (item.code === 'pageSize') {
            this.$set(this.apiVerificationForm, item.code, 10)
          } else {
            this.$set(this.apiVerificationForm, item.code, '')
          }
        })
      },
    },
    activeName(val) {
      if (val === 'second') {
        this.getOpenApiRequestUri()
      }
    },
  },
  methods: {
    // 上移或下移
    async changeFileLevel(type, index, data) {
      let operData = ''
      if (data === 'inputData') {
        operData = this.inputData
      } else {
        operData = this.outPutData
      }
      const currentIndex = type === 'up' ? index - 1 : index + 1
      const temp = operData[index]
      operData[index] = operData[currentIndex]
      operData[currentIndex] = temp
      this.refreshTable = false
      this.$nextTick(async () => {
        this.refreshTable = true
      })
    },
    // 获取Api请求url
    async getOpenApiRequestUri() {
      const id = this.$route.query.id ? this.$route.query.id : this.id
      const applyApplicationId = this.$route.query.applyApplicationId
        ? this.$route.query.applyApplicationId
        : ''
      const [err, res] = await openApiApi.getOpenApiRequestUri({
        openApiId: id,
        applyApplicationId,
      })
      if (!err) {
        const fileServer = Wiz.GetModuleServer('open-api-management')
        this.apiAddress = `${fileServer}${res}`
      }
    },
    // 验证
    async apiVertify() {
      this.$refs.apiVerificationForm.validate(async (valid) => {
        if (valid) {
          const reqData = _.cloneDeep(this.apiVerificationForm)
          // 查询方式为在范围内和不在范围内时，查询参数要传数组格式
          Object.keys(reqData).forEach((key) => {
            _.map(this.queryList, (qItem) => {
              if (key === qItem.code && _.includes([2, 3], qItem.queryMode) && reqData[key]) {
                reqData[key] = JSON.parse(reqData[key])
              }
            })
          })
          this.apiTypeTableLoading = true
          if (this.applyForm.method === 1) {
            // get方法
            if (!_.isEmpty(reqData)) {
              axios
                .get(`${this.apiAddress}&${qs.stringify(reqData)}`)
                .then((response) => {
                  this.handleResponseData(response)
                })
                .catch((error) => {
                  this.$message.error(error.response.data.message)
                })
            } else {
              axios
                .get(`${this.apiAddress}`)
                .then((response) => {
                  this.handleResponseData(response)
                })
                .catch((error) => {
                  this.$message.error(error.response.data.message)
                })
            }
          } else if (this.applyForm.method === 2) {
            if (this.applyForm.isPostQuery === 1) {
              // post查询
              axios
                .post(`${this.apiAddress}`, reqData)
                .then((response) => {
                  this.handleResponseData(response)
                })
                .catch((error) => {
                  this.$message.error(error.response.data.message)
                })
            } else if (this.applyForm.isPostQuery === 0) {
              // post新增
              if (this.queryTableData.length > 0) {
                axios
                  .post(`${this.apiAddress}`, this.queryTableData)
                  .then((response) => {
                    this.handleResponseData(response)
                  })
                  .catch((error) => {
                    this.$message.error(error.response.data.message)
                  })
              } else {
                this.$message.warning('输入不能为空')
              }
            }
          } else if (this.applyForm.method === 3) {
            // put方法
            if (this.queryTableData.length > 0) {
              axios
                .put(`${this.apiAddress}`, this.queryTableData)
                .then((response) => {
                  this.handleResponseData(response)
                })
                .catch((error) => {
                  this.$message.error(error.response.data.message)
                })
            } else {
              this.$message.warning('输入不能为空')
            }
          } else if (this.applyForm.method === 4) {
            // delete方法
            if (this.queryTableData.length > 0) {
              axios
                .delete(`${this.apiAddress}`, { data: this.queryTableData })
                .then((response) => {
                  this.handleResponseData(response)
                })
                .catch((error) => {
                  this.$message.error(error.response.data.message)
                })
            } else {
              this.$message.warning('输入不能为空')
            }
          }
        }
      })
    },
    // 处理响应数据
    handleResponseData(response) {
      this.apiTypeTableLoading = false
      this.apiTypeTableHeader = []
      this.apiTypeTableData = []
      this.expression = JSON.stringify(response.data, null, '\t')
      // this.apiTypeTableHeader = res.data.data.headers
      // 分页的请求单独处理
      if (response.data.data.items && response.data.data.totalCount) {
        this.apiTypeTableData = response.data.data.items
        if (response.data.data.items.length > 0) {
          Object.keys(this.apiTypeTableData[0]).forEach((key) => {
            this.apiTypeTableHeader.push({ label: key, prop: key })
          })
        }
        return
      }
      if (response.data.data.length > 0) {
        this.apiTypeTableData = response.data.data
        Object.keys(this.apiTypeTableData[0]).forEach((key) => {
          this.apiTypeTableHeader.push({ label: key, prop: key })
        })
      }
    },
    // 是否为 post 类型查询接口
    changeisPostQuery(val) {
      if (val) {
        this.getUrlPerfix(1)
      } else {
        this.getUrlPerfix(0)
      }
    },
    // 修改url前缀（post 查询接口是 /openapi/query，其他是/openapi）
    changeUrlPerfix(val) {
      this.getUrlPerfix(0)
      this.isPost = false
      _.map(this.apiMethods, (item) => {
        if (item.label === 'POST' && val === item.value) {
          this.isPost = true
        }
      })
    },
    // 获取OpenApi的url前缀(是否为 post 类型查询接口，0=否，1=是)
    async getUrlPerfix(val) {
      const [err, res] = await openApiApi.getUrlPrefix({ isPostQuery: val })
      if (!err) {
        this.urlPerfix = res
        if (this.$route.query.id && !this.applyForm.url) {
          const url = this.applyForm.address.replace(this.urlPerfix, '')
          this.$set(this.applyForm, 'url', url)
        }
      }
    },
    // api请求方式
    async findApiMethod() {
      const [err, res] = await openApiApi.getAllowedRequestMethods()
      if (!err) {
        this.apiMethods = _.map(res, (item) => {
          return {
            label: item.item2,
            value: item.item1,
          }
        })
      }
    },
    // api类型
    async findApiType() {
      const [err, res] = await openApiApi.getDistinctApiType()
      if (!err) {
        this.apiTypes = _.map(res, (item) => {
          return {
            label: item,
            value: item,
          }
        })
      }
    },
    // 数据类型
    async findDataType() {
      const [err, res] = await openApiApi.getParamValueTypes()
      if (!err) {
        this.dataTypes = _.map(res, (item) => {
          return {
            label: item.item2,
            value: item.item1,
          }
        })
      }
    },
    // 查询方式
    async findQueryMode() {
      const [err, res] = await openApiApi.getParamQueryModes()
      if (!err) {
        this.queryModes = _.map(res, (item) => {
          return {
            label: item.item2,
            value: item.item1,
          }
        })
      }
    },
    // 获取参数类型（输入、输出）
    async findParamTypes() {
      const [err, res] = await openApiApi.getParamTypes()
      if (!err) {
        this.paramTypes = res
      }
    },
    // 新增输入字段
    addInputCode() {
      this.inputData.push({})
    },
    // 新增输出字段
    addOutputCode() {
      this.outPutData.push({})
    },
    // 新增post新增参数
    addQueryData() {
      const addOne = {}
      _.map(this.queryHeaders, (item) => {
        addOne[item.prop] = ''
      })
      this.queryTableData.push(addOne)
    },
    // 返回
    goBack() {
      this.$router.go(-1)
    },
    // 新增和修改api
    updateApi() {
      this.$refs.applyForm.validate(async (valid) => {
        if (valid) {
          // 输入的校验
          let inputFlag = false
          let inputIndex = ''
          let inputField = ''
          _.map(this.inputData, (item, index) => {
            if (!item.code) {
              inputField = 'code'
              inputIndex = index
              inputFlag = true
            } else if (!item.name) {
              inputField = 'name'
              inputIndex = index
              inputFlag = true
            } else if (!item.type) {
              inputField = 'type'
              inputIndex = index
              inputFlag = true
            }
            //  else if (!item.queryMode) {
            //   inputField = 'queryMode'
            //   inputIndex = index
            //   inputFlag = true
            // }
          })
          if (inputFlag) {
            let inputTips = ''
            if (inputField === 'code') {
              inputTips = '参数代码'
            } else if (inputField === 'name') {
              inputTips = '参数名称'
            } else if (inputField === 'type') {
              inputTips = '数据类型'
            }
            //  else if (inputField === 'queryMode') {
            //   inputTips = '查询方式'
            // }
            this.$message.warning(`输入第${inputIndex + 1}行的${inputTips}不能为空`)
            return
          }
          // 输出的校验
          let outputFlag = false
          let outputIndex = ''
          let outputField = ''
          _.map(this.outPutData, (item, index) => {
            if (!item.code) {
              outputField = 'code'
              outputIndex = index
              outputFlag = true
            } else if (!item.name) {
              outputField = 'name'
              outputIndex = index
              outputFlag = true
            } else if (!item.type) {
              outputField = 'type'
              outputIndex = index
              outputFlag = true
            }
          })
          if (outputFlag) {
            let outputTips = ''
            if (outputField === 'code') {
              outputTips = '参数代码'
            } else if (outputField === 'name') {
              outputTips = '参数名称'
            } else if (outputField === 'type') {
              outputTips = '数据类型'
            }
            this.$message.warning(`输出第${outputIndex + 1}行的${outputTips}不能为空`)
            return
          }
          const model = this.applyForm
          this.applyForm.address = `${this.urlPerfix}${this.applyForm.url}`
          _.map(this.paramTypes, (item) => {
            if (item.item2 === '输入参数') {
              _.map(this.inputData, (iItem) => {
                iItem.paramType = item.item1
                return iItem
              })
            }
            if (item.item2 === '输出参数') {
              _.map(this.outPutData, (oItem) => {
                oItem.paramType = item.item1
                return oItem
              })
            }
          })
          model.openApiParamSettings = this.inputData.concat(this.outPutData)
          model.openApiParamSettings = _.map(model.openApiParamSettings, (item, index) => {
            if (item.queryMode === '') {
              item.queryMode = null
            }
            item.seqNo = index
            return item
          })
          this.pageLoading = true
          if (this.$route.query.id) {
            // 修改
            const [err, res] = await openApiApi.update(this.$route.query.id, { body: model })
            if (!err) {
              this.$message.success('保存成功')
            }
          } else {
            // 新增
            const [err, res] = await openApiApi.create({ body: model })
            if (!err) {
              this.$message.success('保存成功')
              this.editType = 'edit'
              this.id = res.id
            }
          }
          this.pageLoading = false
        }
      })
    },
    // 发布api
    releaseApi() {
      this.$refs.applyForm.validate(async (valid) => {
        if (valid) {
          // if (this.inputData.length === 0) {
          //   this.$message.warning('输入不能为空')
          //   return
          // }
          const model = this.applyForm
          this.applyForm.address = `${this.urlPerfix}${this.applyForm.url}`
          _.map(this.paramTypes, (item) => {
            if (item.item2 === '输入参数') {
              _.map(this.inputData, (iItem) => {
                iItem.paramType = item.item1
                return iItem
              })
            }
            if (item.item2 === '输出参数') {
              _.map(this.outPutData, (oItem) => {
                oItem.paramType = item.item1
                return oItem
              })
            }
          })
          model.openApiParamSettings = this.inputData.concat(this.outPutData)
          model.openApiParamSettings = _.map(model.openApiParamSettings, (item) => {
            if (item.queryMode === '') {
              item.queryMode = null
            }
            return item
          })
          const id = this.$route.query.id ? this.$route.query.id : this.id
          const [err, res] = await openApiApi.publish(id, { body: model })
          if (!err) {
            this.$message.success('发布成功')
          }
        }
      })
    },
    // 删除输入字段
    deleteInputCode(row) {
      this.$confirm('是否确定要删除该字段?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.inputData = _.difference(this.inputData, [row])
          this.$message.success('删除成功')
        })
        .catch(() => {
          this.$message.info('取消删除')
        })
    },
    // 删除输出字段
    deleteOutputCode(row) {
      this.$confirm('是否确定要删除该字段?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.outPutData = _.difference(this.outPutData, [row])
          this.$message.success('删除成功')
        })
        .catch(() => {
          this.$message.info('取消删除')
        })
    },
    // 删除post新增传参
    deleteQueryData(row) {
      this.$confirm('是否确定要删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.queryTableData = _.difference(this.queryTableData, [row])
          this.$message.success('删除成功')
        })
        .catch(() => {
          this.$message.info('取消删除')
        })
    },
    // 查询api详情
    async findDetail(id) {
      const [err, res] = await openApiApi.get(id)
      this.pageLoading = false
      if (!err) {
        this.applyForm = res
        this.isPost = this.applyForm.method === 2
        if (this.applyForm.isPostQuery === 1) {
          this.getUrlPerfix(1)
        } else {
          this.getUrlPerfix(0)
        }
        _.map(this.paramTypes, (item) => {
          if (item.item2 === '输入参数') {
            this.inputData = _.filter(res.openApiParamSettings, (iItem) => {
              return iItem.paramType === item.item1
            })
          }
          if (item.item2 === '输出参数') {
            this.outPutData = _.filter(res.openApiParamSettings, (oItem) => {
              return oItem.paramType === item.item1
            })
          }
        })
      }
    },
  },
  async created() {
    this.editType = !_.isEmpty(this.$route.query) ? this.$route.query.type : 'create'
    if (this.editType === 'verify') {
      this.activeName = 'second'
    }
    this.pageLoading = true
    // 获取请求方式
    await this.findApiMethod()
    // 获取API类型
    await this.findApiType()
    // 获取数据类型
    await this.findDataType()
    // 获取查询方式
    await this.findQueryMode()
    // 获取参数类型（输入、输出）
    await this.findParamTypes()
    if (!_.isEmpty(this.$route.query)) {
      this.findDetail(this.$route.query.id)
      return
    }
    this.pageLoading = false
  },
}
</script>
<style lang="scss" scoped>

.position-relative {
  position: relative;
}
.position-absolute {
  position: absolute;
}
/deep/.el-tabs__content {
  height: calc(100% - 60px);
}
/deep/.el-card__body {
  height: calc(100% - 60px);
}
.card-type /deep/.el-card__body {
  height: 100% !important;
  /deep/.el-tabs {
    height: 100% !important;
    /deep/.el-tabs__content {
      height: calc(100% - 40px) !important;
      /deep/.el-tab-pane {
        height: 100% !important;
        .CodeMirror {
          height: 100%;
        }
      }
    }
  }
}
/deep/.el-table__body-wrapper {
  overflow-x: auto;
  overflow-y: auto;
}

</style>
<style lang="scss">

.CodeMirror {
  height: 100%;
}

</style>
